document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.copy-btn');

  if (!buttons.length) return;

  buttons.forEach(function (btn) {
    btn.addEventListener('click', async function () {
      const code = btn.dataset.code;

      try {
        await navigator.clipboard.writeText(code);
      } catch (err) {
        // Fallback
        const fallback = document.createElement('textarea');
        fallback.value = code;
        fallback.setAttribute('readonly', '');
        fallback.style.position = 'absolute';
        fallback.style.left = '-9999px';
        document.body.appendChild(fallback);
        fallback.select();
        try {
          document.execCommand('copy');
        } catch (e) {
          console.error('Fallback copy failed', e);
        }
        document.body.removeChild(fallback);
      }

      btn.textContent = '¡Copiado!';
      setTimeout(() => {
        btn.textContent = 'Copiar';
      }, 1400);
    });
  });
});
